<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <!-- The prompt is wrapped rather than left as a bare text node so that it, and not the phrase field, is
       the dialog content's first element child: Material zeroes `margin-top` on whatever that is, which
       silently defeated the field's own top spacing. `m-0` keeps ordinary confirmations rendering exactly
       as they did before the field existed. -->
  <p class="m-0">{{ data.prompt }}</p>

  @if (requiredPhrase) {
    <!-- Typing the name out is the point: it cannot be satisfied without having read which thing is about
         to be destroyed. cdkFocusInitial sits here rather than on "No" so the field is ready to type in;
         with no phrase there is no cdkFocusInitial at all and the dialog falls back to focusing "No". -->
    <!-- mt-6, not less: the outline appearance floats its label above the field's top edge, which collides
         with the last line of the prompt at a smaller gap. -->
    <mat-form-field class="w-full mt-6" subscriptSizing="dynamic">
      <mat-label>{{ 'generic.confirm-phrase.label' | translate }}</mat-label>
      <input
        matInput
        cdkFocusInitial
        type="text"
        autocomplete="off"
        spellcheck="false"
        [value]="typed()"
        (input)="onInput($event)"
        (keyup.enter)="confirm()" />
      <!-- A hint rather than a mat-error: this input has no NgControl, so the field never enters an error
           state and a mat-error would never be rendered at all. -->
      <mat-hint [class.text-red-600]="showMismatch()">
        {{ (showMismatch() ? 'generic.confirm-phrase.mismatch' : 'generic.confirm-phrase.hint') | translate: { phrase: requiredPhrase } }}
      </mat-hint>
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton mat-dialog-close>{{ 'generic.no' | translate }}</button>
  <button matButton class="red-button" [disabled]="!canConfirm()" (click)="confirm()">
    {{ 'generic.yes' | translate }}
  </button>
</mat-dialog-actions>
